import { AstraParagraph, astraTwMerge, DataGrid, DataGridProvider } from '~/astra'
import { getHolidayStyles } from '~/utils/utils'

import { getWeekDividerStyles } from '../../../TablesLayout/shared/styles'
import { ApplyPreviewData } from '../Apply/types'
import { PreviewCell } from './PreviewCell'
import { usePreviewHeaders } from './usePreviewHeaders'

type Props = {
    previewData: ApplyPreviewData
}

export const PractitionersPreview = ({ previewData }: Props) => {
    const practitioners = [...previewData.keys()]
    const dates = [...(previewData.values().next().value?.keys() ?? [])]
    const headers = usePreviewHeaders()

    return (
        <DataGridProvider rows={practitioners} cols={dates} selectionMode="none">
            <DataGrid
                id="practitioner-preview"
                rows={practitioners}
                cols={dates}
                headers={headers}
                body={{
                    rowHeader: practitioner => <AstraParagraph className="truncate px-2 py-1">{practitioner.short_name}</AstraParagraph>,
                    cellRender: (practitioner, date) => {
                        const cell = previewData.get(practitioner)?.get(date)
                        return cell ? <PreviewCell cell={cell} /> : null
                    },
                    cellClassName: (_practitioner, { date }) => astraTwMerge('p-0', getWeekDividerStyles(date), getHolidayStyles(date)),
                }}
            />
        </DataGridProvider>
    )
}
